import { useEffect, useState } from 'react';
import Content from './content/Content';
import InvalidToken from './invalid_token/InvalidToken';
import useSessionToken from '../../entities/stores/useSessionToken';
import StoreWebservice from '../../webservices/StoreWebservice';
import './SettingsPage.scss';

const { Card, CardSection, PaymongoLogo } = require('@paymongo/seeds');

interface Store {
  app: string;
  trade_name?: string;
}

const storeWebservice = new StoreWebservice();
const SettingsPage = () => {
  const id: string = new URLSearchParams(document.location.search).get('store_id') || '';
  const sessionToken: string = new URLSearchParams(document.location.search).get('session_token') || '';
  const { data, error } = useSessionToken(id, sessionToken);
  const [store, setStore] = useState<Store | undefined>()
  const invalidSession: boolean = !id || !sessionToken || error;

  const getStore = () => {
    storeWebservice.fetchStore(id, sessionToken)
      .then(({ data }) => {
        setStore(data as Store)
      })
  }

  useEffect(() => getStore(), []);

  const isCard = store?.app === 'card'

  const renderContent = () => {
    if (invalidSession) return <InvalidToken />;

    return <Content id={id} sessionToken={sessionToken} getStore={getStore} store={store} />;
  }

  return (
    <div className="settings-page-screen --m-5xl">
      {!!store && (
        <title>
          {isCard ? 'Credit/Debit Card Payments via PayMongo' : 'Secure Payments via PayMongo'}
        </title>
      )}
      <Card>
        <CardSection className="settings-page-screen__header">
          <PaymongoLogo logotype />
        </CardSection>

        { renderContent() }
      </Card>
    </div>
  );
}

export default SettingsPage;
